import styled from 'styled-components';

export const Container = styled.div<{ $appearance?: 'default' | 'segmented' }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: ${(props) => props.$appearance === 'segmented' ? '22px' : '3%'};
    background: ${(props) =>
      props.$appearance === 'segmented'
        ? 'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,251,255,0.98) 100%)'
        : '#fff'};
    box-shadow: ${(props) =>
      props.$appearance === 'segmented'
        ? '0 20px 42px rgba(23, 55, 77, 0.09)'
        : '0px 2px 10px rgba(0, 0, 0, 0.1)'};
    border-radius: ${(props) => props.$appearance === 'segmented' ? '24px' : '8px'};
    padding: ${(props) => props.$appearance === 'segmented' ? '12px' : '0'};
`;

interface IRowContainer {
    justifyContent?: string;
    $appearance?: 'default' | 'segmented';
}


export const RowContainer = styled.div<IRowContainer>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: ${(props) => props.justifyContent || "flex-start"};
    width: 100%;
    min-height: 60px;
    gap: ${(props) => props.$appearance === 'segmented' ? '10px' : '0'};

    @media (max-width: 900px) {
      flex-direction: column;
      gap: 12px;
    }
`;

export const ContainerItemType = styled.div<{ $appearance?: 'default' | 'segmented'; $focused?: boolean }>`
    height: 100%;
    padding-top: ${(props) => props.$appearance === 'segmented' ? '0' : '10px'};
    display: flex;
    flex-direction: column;
    width: ${(props) => props.$appearance === 'segmented' ? '100%' : 'auto'};
    flex: 1 1 0;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: ${(props) => props.$appearance === 'segmented' ? '0 1%' : '0'};
    border-radius: ${(props) => props.$appearance === 'segmented' ? '18px' : '0'};
    background: ${(props) =>
      props.$appearance === 'segmented'
        ? props.$focused
          ? 'linear-gradient(135deg, rgba(198,1,107,0.08) 0%, rgba(45,116,156,0.10) 100%)'
          : 'transparent'
        : 'transparent'};
    border: ${(props) =>
      props.$appearance === 'segmented'
        ? props.$focused
          ? '1px solid rgba(45, 116, 156, 0.22)'
          : '1px solid transparent'
        : 'none'};
    transition: transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease, border-color 0.18s ease;

    &:hover {
      transform: ${(props) => props.$appearance === 'segmented' ? 'translateY(-1px)' : 'none'};
      box-shadow: ${(props) => props.$appearance === 'segmented' ? '0 14px 26px rgba(23, 55, 77, 0.08)' : 'none'};
      background: ${(props) =>
        props.$appearance === 'segmented'
          ? props.$focused
            ? 'linear-gradient(135deg, rgba(198,1,107,0.09) 0%, rgba(45,116,156,0.12) 100%)'
            : 'rgba(45, 116, 156, 0.04)'
          : 'transparent'};
    }

    @media (max-width: 900px) {
      width: 100%;
      margin: 0;
    }
`;

export const UnderlineItemType = styled.div`
    width: calc(100% - 36px);
    max-width: 220px;
    height: 3px;
    background-color: #2D749C;
    border-radius: 999px;
    margin-top: 8px;
`;

export const SegmentedItemContent = styled.div`
    width: 100%;
    min-height: 72px;
    padding: 0 18px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const SegmentedLabelRow = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    text-align: center;
`;

export const SegmentedInfoButton = styled.button`
    width: 24px;
    height: 24px;
    border-radius: 999px;
    border: none;
    background: rgba(45, 116, 156, 0.10);
    color: #2D749C;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    cursor: help;
`;

